import { writable } from "svelte/store";

export type ConsentLevel = 1 | 2 | 3 | 4;
export type ConsentAnswer = (ConsentLevel | undefined)[];

export const versionAppName = "ishavskraft_no";
export const versionDate = "2025-09-12";
export const administrateCookieChoice = writable<boolean>(false);
export const consentAnswerStore = writable<ConsentAnswer>();

export default consentAnswerStore;
